module.exports = __webpack_public_path__ + "static/media/android.5ee60ecb.svg";